export default {
    dateOrder: {
        method: 'GET',
        url: '/manage-system/finance/dateOrder/{date}/{buyWay}',
        name: '订单明细列表',
    },
    dateTicketReport: {
        method: 'GET',
        url: '/manage-system/finance/dateTicketReport/{shopId}/{cashierId}/{date}/{platformId}/{platformType}',
        name: '票劵收支明细报表',
    },
    detailList: {
        method: 'POST',
        url: '/manage-system/finance/detailList',
        name: '财务管理明细列表',
    },
    list: {
        method: 'GET',
        url: '/manage-system/finance/list/{shopId}/{date}',
        name: '财务管理列表',
    },
    modifyDetail: {
        method: 'POST',
        url: '/manage-system/finance/modifyDetail',
        name: '修改明细金额',
    },
    operateList: {
        method: 'POST',
        url: '/manage-system/finance/operateList',
        name: '操作记录列表',
    },
    count: {
        method: 'GET',
        url: '/manage-system/finance/count/{shopId}/{date}',
        name: '财务管理列表统计',
    },
    refund: {
        method: 'GET',
        url: '/manage-system/finance/refund/{shopId}/{cashierId}/{date}/{platformId}/{platformType}',
        name: '退款',
    },
    financeManualDetail: {
        method: 'GET',
        url: '/manage-system/finance/manual/detail',
        name: '手工交账详情',
    },
    financeList: {
        method: 'GET',
        url: '/manage-system/finance/query',
        name: '财务管理列表',
    },
    refundRecord: {
        method: 'GET',
        url: '/manage-system/finance/refund/{shopId}/{cashierId}/{date}/{platformId}/{platformType}',
        name: '退款记录',
    },
    refundExport: {
        method: 'GET',
        url: '/manage-system/finance/export',
        name: '退款记录',
    },
    exportExcelConfirmPayment: {
        method: 'POST',
        url: '/manage-system/finance/export/confirmPayment',
        name: '确认收付报表 导出',
    },
    exportExcelReceivable: {
        method: 'POST',
        url: '/manage-system/finance/export/receivable',
        name: '应收账款报表 导出',
    },

}
